var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1768802932065,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4766,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M938.666667 554.666667h-85.333334V298.666667h-358.997333l-85.333333-85.333334H170.666667v597.333334h384v85.333333H128a42.666667 42.666667 0 0 1-42.666667-42.666667V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667h316.330667l85.333333 85.333333H896a42.666667 42.666667 0 0 1 42.666667 42.666667v298.666667z m-170.666667 170.666666v-149.333333l213.333333 192-213.333333 192V810.666667h-128v-85.333334h128z",
    fill: "#515151",
    "p-id": 4767
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMove);
export default __webpack_public_path__ + "static/media/file-move.25e58297ec6b197287e3d7efa0e7466e.svg";
export { ForwardRef as ReactComponent };